export var BaseV2API = "";
